import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const CustomImageTablePagination = ({ rowsPerPage, setRowsPerPage, setPage, options }) => {
    const handleChange = (event, newValue) => {
        if (newValue !== null) {
            setRowsPerPage(newValue);
            setPage(0);
        }
    };

    return (
        <ToggleButtonGroup
            value={rowsPerPage}
            exclusive
            onChange={handleChange}
            size="small"
            color="primary"
        >
            {options.map(option => (
                <ToggleButton key={option} value={option}>
                    {option}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default CustomImageTablePagination;
